// copy to vben-admin

const toString = Object.prototype.toString

export const is = (val: unknown, type: string) => {
  return toString.call(val) === `[object ${type}]`
}

export const isDef = <T = unknown>(val?: T): val is T => {
  return typeof val !== 'undefined'
}

export const isUnDef = <T = unknown>(val?: T): val is T => {
  return !isDef(val)
}

export const isObject = (val: any): val is Record<any, any> => {
  return val !== null && is(val, 'Object')
}

export const isEmpty = <T = unknown>(val: T): val is T => {
  if (isArray(val) || isString(val)) {
    return val.length === 0
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0
  }

  return false
}

export const isDate = (val: unknown): val is Date => {
  return is(val, 'Date')
}

export const isNull = (val: unknown): val is null => {
  return val === null
}

export const isNullAndUnDef = (val: unknown): val is null | undefined => {
  return isUnDef(val) && isNull(val)
}

export const isNullOrUnDef = (val: unknown): val is null | undefined => {
  return isUnDef(val) || isNull(val)
}

export const isNumber = (val: unknown): val is number => {
  return is(val, 'Number')
}

export const isPromise = <T = any>(val: unknown): val is Promise<T> => {
  return is(val, 'Promise') && isObject(val) && isFunction(val.then) && isFunction(val.catch)
}

export const isString = (val: unknown): val is string => {
  return is(val, 'String')
}

export const isFunction = (val: unknown): val is Function => {
  return typeof val === 'function'
}

export const isBoolean = (val: unknown): val is boolean => {
  return is(val, 'Boolean')
}

export const isRegExp = (val: unknown): val is RegExp => {
  return is(val, 'RegExp')
}

export const isArray = (val: any): val is Array<any> => {
  return val && Array.isArray(val)
}

export const isWindow = (val: any): val is Window => {
  return typeof window !== 'undefined' && is(val, 'Window')
}

export const isElement = (val: unknown): val is Element => {
  return isObject(val) && !!val.tagName
}

export const isMap = (val: unknown): val is Map<any, any> => {
  return is(val, 'Map')
}

export const isServer = typeof window === 'undefined'

export const isClient = !isServer

export const isUrl = (path: string): boolean => {
  try {
    new URL(path)
    return true
  } catch (_error) {
    return false
  }
}

export const isDark = (): boolean => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

// 是否是图片链接
export const isImgPath = (path: string): boolean => {
  return /(https?:\/\/|data:image\/).*?\.(png|jpg|jpeg|gif|svg|webp|ico)/gi.test(path)
}

export const isEmptyVal = (val: any): boolean => {
  return val === null || val === undefined
}

export const isFireFax = () => {
  const inBrowser = typeof window !== 'undefined'
  const UA = inBrowser && window.navigator.userAgent.toLowerCase()
  return UA && UA.indexOf('firefox') > 0
}

// 校驗hkid
export const IsHKID = (str: string) => {
  const strValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

  // basic check length
  if (!str) return false
  if (str.length < 8) return false

  // handling bracket
  if (str.charAt(str.length - 3) == '(' && str.charAt(str.length - 1) == ')')
    str = str.substring(0, str.length - 3) + str.charAt(str.length - 2)

  // convert to upper case
  str = str.toUpperCase()

  // regular expression to check pattern and split
  const hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/
  const matchArray = str.match(hkidPat)

  // not match, return false
  if (matchArray == null) return false

  // the character part, numeric part and check digit part
  const charPart = matchArray[1]
  const numPart: any = matchArray[2]
  const checkDigit = matchArray[3]

  // calculate the checksum for character part
  let checkSum = 0
  if (charPart.length == 2) {
    checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)))
    checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)))
  } else {
    checkSum += 9 * 36
    checkSum += 8 * (10 + strValidChars.indexOf(charPart))
  }

  // calculate the checksum for numeric part
  for (let i = 0, j = 7; i < numPart.length; i++, j--) checkSum += j * numPart.charAt(i)

  // verify the check digit
  const remaining = checkSum % 11
  const verify = remaining == 0 ? 0 : 11 - remaining

  return verify.toString() === checkDigit || (verify == 10 && checkDigit == 'A')
}
